import React from "react";
import logo from "../images/logo_dark.png";

function Footer() {
  return (
    <div className="w-full bg-white shadow py-4  flex items-center justify-between px-12">
      <img className="w-10" src={logo} alt="" />
      <p className="text-gray-500 font-medium">
        Copyright © {new Date().getFullYear()} Slides With. All rights reserved.
      </p>
    </div>
  );
}

export default Footer;
